<template>
  <!-- Figma UQ "Quote Summary": "Submit Quote" teal outline pill with a teal send circle, bottom-right of the page
       (the TradeCall "Important:" line is shown once, in QuoteSummary's card) -->
  <button type="button"
    class="group flex items-center justify-center gap-[10px] h-[40px] pl-[15px] pr-[7px] rounded-full border-1 border-[#29C6CD] font-roboto text-[14px] laptop:text-[16px] transition duration-300 mobile:bg-[#29C6CD] mobile:text-white laptop:bg-white laptop:text-[#29C6CD] laptop:hover:bg-[#29C6CD] laptop:hover:text-white"
    @click="updateSummary">
    Submit Quote
    <span
      class="w-[26px] h-[26px] rounded-full flex items-center justify-center transition duration-300 mobile:bg-white laptop:bg-[#29C6CD] laptop:group-hover:bg-white">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"
        class="mobile:text-[#29C6CD] laptop:text-white laptop:group-hover:text-[#29C6CD]">
        <path d="M21 3 3 10.5l7.5 3L21 3Zm0 0-7.5 18-3-7.5" fill="currentColor" stroke="currentColor" stroke-width="1.6"
          stroke-linejoin="round" />
      </svg>
    </span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { param } from "jquery";
const toast = useToast();

export default {

    props: ['no_of_units', 'validateBeforeSubmit', 'saveBeforeSubmit'],
    components: {
    },

    data() {
        return {

        };
    },
    computed: {
        ...mapGetters([
            "quoteDetail",
        ]),
        
        isPartnerQuote() {
            return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
        }
    },


    mounted() {

    },

    methods: {
        ...mapActions([
            "postQuoteSummary",
        ]),

        updateSummary() {
            if (typeof this.validateBeforeSubmit === 'function' && !this.validateBeforeSubmit()) {
                return;
            }

            this.$dialog.show({
                title: "Submit Quote",
                text: "Are you sure you want to submit this quote?",
                // we are passing callback method for our confirm button
                onConfirm: async () => {
                    if (typeof this.saveBeforeSubmit === 'function') {
                        const isSaved = await this.saveBeforeSubmit();
                        if (!isSaved) {
                            return;
                        }
                    }

                    if (this.isPartnerQuote) {
                        this.postQuoteSummary({
                            url: "/manual-quote/partner/update",
                            params: {
                                manual_quote_id: this.quoteDetail.id,
                                number_of_units: this.no_of_units
                            }
                        });
                    } else {
                        this.postQuoteSummary({
                            url: "/manual-quote/submit-quote",
                            params: {
                                manual_quote_id: this.quoteDetail.id,
                                number_of_units: this.no_of_units
                            }
                        });
                    }
                    
                },
            });
        },
    },
};
</script>